//  export default {
//    name: "LoadingWrapper",
//    data: function() {
//      return { loadCount : 0}
//    },
//    methods: {
//      loadingStart: function() {
//        this.$el
//      },
//      loadingDone: function() {
//        this.$el
//      }
//    }
// //   props: ['loading']
//  }
import { ref, computed } from '@vue/composition-api';

export default function useLoadingWrapper() {

  const loadingCount = ref(0);
  const isLoading = computed(() => loadingCount !== 0);
  function loadingStart() {
    loadingCount.value++;
  }
  function loadingDone() {
    loadingCount.value--;
  }

  return {
    isLoading,
    loadingStart,
    loadingDone
  }

}

